import React, { FC } from 'react';
import { ArrowLeftSmall } from '@wix/wix-ui-icons-common';
import { Box, TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone/i18n';
import { useTemplateBi } from '@components/Hooks/useTemplateBi';
import { TEMPLATES_GALLERY_ENTRY } from '@utils/constants';
import { useTemplateEntry } from '@components/Hooks/useTemplateEntry';
import s from './BackToGalleryButton.module.scss';

const BackToGalleryButton: FC = () => {
  const { logBiClick } = useTemplateBi({ is_mobile: false });
  const { t } = useTranslation();
  const { entry } = useTemplateEntry();

  return entry === TEMPLATES_GALLERY_ENTRY ? (
    <Box className={s.backToTemplateCta}>
      <TextButton
        size="small"
        onClick={() => {
          logBiClick({ clickType: 'Back to Wix Studio templates' });
          window.history.back();
        }}
        skin="dark"
        prefixIcon={<ArrowLeftSmall />}
      >
        {t('marketplace.templates-page.back-to-studio-templates-cta')}
      </TextButton>
    </Box>
  ) : (
    <Box height="66px"></Box>
  );
};

export default BackToGalleryButton;
